import styled from 'styled-components'

import addHours from 'date-fns/addHours'
import addMinutes from 'date-fns/addMinutes'
import setMinutes from 'date-fns/setMinutes'
import { ReactElement } from 'react'
import { ITimePickerProps, ITimeUnitChangerProps } from './types'

const Wrapper = styled.div<TSFixMe>`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 0;
`

const CenteredColumn = styled.div<TSFixMe>`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 10px;
`

const ToggleButton = styled.div<TSFixMe>`
  cursor: pointer;
`

const StyledDecreaseButton = styled(ToggleButton)<TSFixMe>`
  transform: rotate(180deg);
`

const Label = styled.div<TSFixMe>`
  margin: 5px 0;
`

const TimeUnitChanger = ({ value, handleDecrease, handleIncrease }: ITimeUnitChangerProps): ReactElement => (
  <CenteredColumn>
    <ToggleButton onClick={handleIncrease}>&#9650;</ToggleButton>
    <Label>{value}</Label>
    <StyledDecreaseButton onClick={handleDecrease}>&#9650;</StyledDecreaseButton>
  </CenteredColumn>
)

const getHour12 = (date?: Date): string => {
  if (!date) {
    return '--'
  }

  return date.getHours() < 12 ? 'AM' : 'PM'
}

const getHours = (date?: Date): string => {
  if (!date) {
    return '--'
  }

  const hours = date.getHours()

  if (hours === 0) {
    return '12'
  } else if (hours > 12) {
    return (hours - 12).toString()
  }

  return hours.toString()
}

export const TimePicker = ({ value, onChange, intervalMinutes = 1 }: ITimePickerProps): ReactElement => {
  const increaseOneHour = (): void => {
    if (!value) {
      onChange(setMinutes(new Date(), 0))
    } else if (value.getHours() === 23) {
      onChange(addHours(value, -23))
    } else {
      onChange(addHours(value, 1))
    }
  }

  const decreaseOneHour = (): void => {
    if (!value) {
      onChange(setMinutes(new Date(), 0))
    } else if (value.getHours() === 0) {
      onChange(addHours(value, 23))
    } else {
      onChange(addHours(value, -1))
    }
  }

  const increaseOneMinute = (): void => {
    if (!value) {
      onChange(setMinutes(new Date(), 0))
    } else if (value.getMinutes() === 60 - intervalMinutes) {
      onChange(addMinutes(value, -(60 - intervalMinutes)))
    } else {
      onChange(addMinutes(value, intervalMinutes))
    }
  }

  const decreaseOneMinute = (): void => {
    if (!value) {
      onChange(setMinutes(new Date(), 0))
    } else if (value.getMinutes() === 0) {
      onChange(addMinutes(value, 60 - intervalMinutes))
    } else {
      onChange(addMinutes(value, -intervalMinutes))
    }
  }

  const increaseHour12 = (): void => {
    if (!value) {
      onChange(setMinutes(new Date(), 0))
    } else if (value.getHours() >= 12) {
      onChange(addHours(value, -12))
    } else {
      onChange(addHours(value, 12))
    }
  }

  const decreaseHour12 = (): void => {
    if (!value) {
      onChange(setMinutes(new Date(), 0))
    } else if (value.getHours() < 12) {
      onChange(addHours(value, 12))
    } else {
      onChange(addHours(value, -12))
    }
  }

  return (
    <Wrapper>
      <TimeUnitChanger value={getHours(value)} handleDecrease={decreaseOneHour} handleIncrease={increaseOneHour} />
      <TimeUnitChanger
        value={value ? value.getMinutes().toString() : '--'}
        handleDecrease={decreaseOneMinute}
        handleIncrease={increaseOneMinute}
      />
      <TimeUnitChanger value={getHour12(value)} handleDecrease={decreaseHour12} handleIncrease={increaseHour12} />
    </Wrapper>
  )
}
